export enum QueryParameters {
  ACCESS_TOKEN = 'access_token',
  ERROR_CODE = 'error_code',
  ORIGIN = 'origin',
  REDIRECT_TO = 'redirect_to',
  REFRESH_TOKEN = 'refresh_token',
  AUTHENTICATION_CODE = 'authentication_code',
  SECONDARY_FACTOR = 'secondary_factor',
  EMAIL = 'email',
  USERNAME = 'username',
}
